import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/a28kkvjMrm67yzJpBLaQqL/mockup_2_inseguridad.png',
  title: 'Reset de Inseguridad: 7 Días para Volver a Tu Centro',
  subtitle: 'Autoestima, calma y alto valor',
  num: 'BONUS 1'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/rgo5XnVVT6jhVD3W8JsTfi/prompt_3_mockup.png',
  title: 'Fórmula Para Ser Única e Inolvidable (Sin Perseguir)',
  subtitle: 'Presencia, estándares y magnetismo',
  num: 'BONUS 2'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/dfLNLyD8WcicEoic8SB1kB/prompt_4_infidelidad.png',
  title: 'Protocolo: Si Él Coquetea / Tiene Amiguitas',
  subtitle: 'Límites claros sin perder tu dignidad',
  num: 'BONUS 3'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/mpVWwaZDVJRzUXZqgpPpQm/radar_infidelidad_mockup.png',
  title: 'Radar de Infidelidad (Sin Paranoia)',
  subtitle: 'Señales reales, límites claros y paz mental',
  num: 'BONUS 4'
}];
export function BonusSection() {
  return <section className="py-10 md:py-14 px-6 bg-blush relative overflow-hidden" data-id="element-16">
      <div className="max-w-6xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-18">
          <div className="inline-flex items-center gap-2 bg-gold/20 text-burgundy font-bold uppercase tracking-widest text-sm px-5 py-2 rounded-full mb-4" data-id="element-19">
            <GiftIcon className="w-4 h-4" data-id="element-20" />
            <span data-id="element-21">Incluidos gratis con tu compra</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-serif text-burgundy" data-id="element-22">
            4 Bonuses Exclusivos{' '}
            <span className="text-gold italic" data-id="element-23">de Regalo</span>
          </h2>
          <p className="text-base md:text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-24">
            Además del eBook principal, recibirás estas 4 guías adicionales para
            blindar tu transformación.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-25">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gold/15 flex flex-col" data-id="element-26">
              <div className="relative bg-cream p-4 flex items-center justify-center" data-id="element-27">
                <div className="absolute top-3 left-3 bg-gold text-burgundy font-bold px-3 py-1 text-[11px] uppercase tracking-widest rounded-full shadow-sm z-10" data-id="element-28">
                  {bonus.num}
                </div>
                <div className="absolute top-3 right-3 bg-burgundy text-cream font-bold px-3 py-1 text-[11px] uppercase tracking-widest rounded-full shadow-sm z-10" data-id="element-29">
                  Gratis
                </div>
                <img src={bonus.image} alt={bonus.title} className="w-full max-w-[280px] h-40 md:h-48 object-contain mx-auto" data-id="element-30" />
              </div>
              <div className="p-5 flex flex-col flex-grow" data-id="element-31">
                <h3 className="text-lg font-bold text-burgundy mb-2 font-serif leading-snug" data-id="element-32">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed italic font-serif" data-id="element-33">
                  {bonus.subtitle}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}